import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../../utils/request';
import { sha256 } from '../../../utils/sha256';
import { message } from '../../../components/Message';
import ym from 'react-yandex-metrika';

export const sendPhone = createAsyncThunk(
    'profile/sendPhone',
    async (data, {rejectWithValue }) => {
        try {
            localStorage.setItem("loginHash", sha256(data.phone));
            const response = await request("ClientAuthService", "SendCodeToPhone", {
                phone: data.phone,
                SendCodeBy: data.SendCodeBy
            });

            if (response.result) {
                message({ type: 'default', title: 'Авторизация', body: `Код отправлен ${data.SendCodeBy === 'Telegram' ? 'в Telegram' : 'в СМС'} на телефон ${data.phone}` });
                return {
                    phone: data.phone,
                    session: response.data.session,
                };
            } else if (response.errors && Array.isArray(response.errors) && response.errors.length) {
                message({ type: 'default', title: 'Ошибка', body: response.errors[0].description });
                return rejectWithValue(response.errors[0].description);
            } else if (response.message || response.data?.message) {
                message({ type: 'default', title: 'Ошибка', body: response.message || response.data?.message });
                return rejectWithValue(response.message || response.data?.message);
            } else {
                message({ type: 'default', title: 'Ошибка', body: 'Непредвиденная ошибка sendPhone' });
                return rejectWithValue('Непредвиденная ошибка sendPhone');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const sendCode = createAsyncThunk(
    'profile/sendCode',
    async (code, {getState, rejectWithValue }) => {
        const { currentPartner } = getState().partner;

        try {
            localStorage.setItem("codeHash", sha256(code));
            const response = await request("ClientAuthService", "CreateTokenBySession");

            if (response.result) {
                if (currentPartner === 240289) {
                    ym('reachGoal','stolovkin_auth');
                } else {
                    ym('reachGoal','target_auth');
                }

                return {
                    token: response.data.token,
                    refreshToken: response.data.refreshToken,
                };
            } else if (response.errors && Array.isArray(response.errors) && response.errors.length) {
                message({ type: 'default', title: 'Ошибка', body: response.errors[0].description });
                return rejectWithValue(response.errors[0].description);
            } else if (response.message || response.data?.message) {
                message({ type: 'default', title: 'Ошибка', body: response.message || response.data?.message });
                return rejectWithValue(response.message || response.data?.message);
            } else {
                message({ type: 'default', title: 'Ошибка', body: 'Непредвиденная ошибка sendCode' });
                return rejectWithValue('Непредвиденная ошибка sendCode');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const logout = createAsyncThunk(
    'profile/logout',
    async (_, { rejectWithValue }) => {
        const clearStorage = () => {
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("session");
            localStorage.removeItem("loginHash");
            localStorage.removeItem("codeHash");
            localStorage.removeItem("typeAuth");
            localStorage.removeItem("cart");
            localStorage.removeItem("check");
        }

        try {
            const response = await request("ClientAuthService", "DeleteToken");

            if (response.result) {
                clearStorage();
                return response.data;
            } else {
                clearStorage();
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const getProfile = createAsyncThunk(
    'profile/getProfile',
    async (_, { rejectWithValue }) => {
        try {
            const response = await request("AppDinnerController", "GetProfile");

            if (response.result) {
                return response.data;
            } else {
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const saveProfile = createAsyncThunk(
    'profile/saveProfile',
    async (data, { rejectWithValue }) => {
        try {
            const response = await request("AppDinnerController", "SaveProfile", data);

            if (response.result) {
                message({ type: 'default', title: 'Успех', body: "Профиль обновлен!" });
                return data;
            } else {
                message({ type: 'default', title: 'Ошибка', body: "Профиль не обновлен!" });
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const deleteProfile = createAsyncThunk(
    'profile/deleteProfile',
    async (data, { rejectWithValue }) => {
        try {
            const response = await request("ClientAuthService", "DeleteUserAccount", data);

            if (response.result) {
                message({ type: 'default', title: 'Успех', body: "Профиль удален!" });
                return data;
            } else {
                message({ type: 'default', title: 'Ошибка', body: "Профиль не удален!" });
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const renamePromocode = createAsyncThunk(
    'profile/renamePromocode',
    async (promocode, { rejectWithValue }) => {
        try {
            const response = await request("AppDinnerController", "ChangeMyPromocode", {promocode: promocode});

            if (response.result) {
                message({ type: 'default', title: 'Промокод обновлен!', body: `Ваш личный промокод изменен на "${promocode}"` });
                return promocode;
            } else {
                message({ type: 'default', title: 'Промокод не обновлен!', body: 'Такой промокод уже используется' });
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

export const getWallets = createAsyncThunk(
    'profile/getWallets',
    async (_, { rejectWithValue }) => {
        try {
            const response = await request("AppDinnerController", "GetWalletsInfo", {});

            if (response.result) {
                const { wallets, walletsTransactions } = response.data;

                const walletsWithTransactions = wallets.map(wallet => ({
                    ...wallet,
                    transactions: walletsTransactions.filter(tx => tx.walletTo === wallet.id || tx.walletFrom === wallet.id)
                }));

                return walletsWithTransactions;
            } else {
                return rejectWithValue('Ошибка извлечения данных');
            }
        } catch (error) {
            console.error(error);
            return rejectWithValue('Ошибка подключения');
        }
    }
);

const token = localStorage.getItem('token');
const isAuth = token ? true : false;

const initialState = {
    isAuthModalOpen: false,
    isAuthQuestionModalOpen: false,
    sendPhoneStatus: null,
    phone: null,
    sendCodeStatus: null,
    isCodeValid: null,
    session: null,
    token: null,
    isAuth: isAuth,
    getProfileStatus: null,
    profile: null,
    saveProfileStatus: null,
    deleteProfileStatus: null,
    changePromocodeStatus: null,
    getWalletsStatus: null,
    wallets: null,
};

const resetState = (state) => {
    state.isAuthModalOpen = false;
    state.isAuthQuestionModalOpen = false;
    state.sendPhoneStatus = null;
    state.phone = null;
    state.sendCodeStatus = null;
    state.isCodeValid = null;
    state.session = null;
    state.token = null;
    state.isAuth = false;
    state.getProfileStatus = null;
    state.profile = null;
    state.saveProfileStatus = null;
    state.deleteProfileStatus = null;
    state.changePromocodeStatus = null;
    state.getWalletsStatus = null;
    state.wallets = null;
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    extraReducers: (builder) => {
        builder
            // sendPhone
            .addCase(sendPhone.pending, (state) => {
                state.sendPhoneStatus = 'pending';
            })
            .addCase(sendPhone.fulfilled, (state, action) => {
                state.sendPhoneStatus = 'fulfilled';
                state.phone = action.payload.phone;
                localStorage.setItem("loginHash", sha256(action.payload.phone));
                localStorage.setItem('session', action.payload.session);
            })
            .addCase(sendPhone.rejected, (state) => {
                state.sendPhoneStatus = 'rejected';
            })

            // sendCode
            .addCase(sendCode.pending, (state) => {
                state.sendCodeStatus = 'pending';
            })
            .addCase(sendCode.fulfilled, (state, action) => {
                state.sendCodeStatus = 'fulfilled';
                localStorage.setItem('token', action.payload.token);
                localStorage.setItem("refreshToken", action.payload.refreshToken);
                state.isAuth = true;
                state.isCodeValid = true;
                state.isAuthModalOpen = false;
            })
            .addCase(sendCode.rejected, (state) => {
                state.sendCodeStatus = 'rejected';
                state.isCodeValid = false;
            })

            // logout
            .addCase(logout.fulfilled, (state) => {
                resetState(state);
            })
            .addCase(logout.rejected, (state) => {
                resetState(state);
            })

            // getProfile
            .addCase(getProfile.pending, (state) => {
                state.getProfileStatus = 'pending';
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.getProfileStatus = 'fulfilled';
                state.profile = action.payload;
            })
            .addCase(getProfile.rejected, (state) => {
                state.getProfileStatus = 'rejected';
            })

            // saveProfile
            .addCase(saveProfile.pending, (state) => {
                state.saveProfileStatus = 'pending';
            })
            .addCase(saveProfile.fulfilled, (state, action) => {
                state.saveProfileStatus = 'fulfilled';
                state.profile = {
                    ...state.profile,
                    client: {
                        ...state.profile.client,
                        ...action.payload.client
                    },
                    settings: action.payload.settings !== undefined 
                        ? action.payload.settings 
                        : state.profile.settings
                };
            })
            .addCase(saveProfile.rejected, (state) => {
                state.saveProfileStatus = 'rejected';
            })

            // deleteProfile
            .addCase(deleteProfile.pending, (state) => {
                state.deleteProfileStatus = 'pending';
            })
            .addCase(deleteProfile.fulfilled, (state) => {
                state.deleteProfileStatus = 'fulfilled';
                resetState(state);
            })
            .addCase(deleteProfile.rejected, (state) => {
                state.deleteProfileStatus = 'rejected';
            })

            // renamePromocode
            .addCase(renamePromocode.pending, (state) => {
                state.changePromocodeStatus = 'pending';
            })
            .addCase(renamePromocode.fulfilled, (state, action) => {
                state.changePromocodeStatus = 'fulfilled';
                state.profile.mypromocode.promocode = action.payload;
            })
            .addCase(renamePromocode.rejected, (state) => {
                state.changePromocodeStatus = 'rejected';
            })

            // getWallets
            .addCase(getWallets.pending, (state) => {
                state.getWalletsStatus = 'pending';
            })
            .addCase(getWallets.fulfilled, (state, action) => {
                state.getWalletsStatus = 'fulfilled';
                state.wallets = action.payload;
            })
            .addCase(getWallets.rejected, (state) => {
                state.getWalletsStatus = 'rejected';
            })
    },
    reducers: {
        setIsAuthModalOpen: (state) => {
            state.isAuthModalOpen = true;
            state.isAuthQuestionModalOpen = false;
        },
        setIsAuthModalClose: (state) => {
            state.isAuthModalOpen = false;
            state.phoneSend = false;
            state.errorPhone = false;
            state.errorPhoneServer = false;
            state.sendPhoneStatus = null;
            state.userPhone = null;
            state.sendCodeStatus = null;
        },
        setIsAuthQuestionModalOpen: (state) => {
            state.isAuthQuestionModalOpen = true;
        },
        setIsAuthQuestionModalClose: (state) => {
            state.isAuthQuestionModalOpen = false;
        },
        resetAuthState: (state) => {
            state.sendPhoneStatus = null;
            state.userPhone = null;
            state.sendCodeStatus = null;
            state.isCodeValid = null;
        },
    },
});

export const {
    setIsAuthModalOpen,
    setIsAuthModalClose,
    setIsAuthQuestionModalOpen,
    setIsAuthQuestionModalClose,
    resetAuthState,
} = profileSlice.actions;

export default profileSlice.reducer;
